import { createSlice } from "@reduxjs/toolkit";
import { MEDIA_INFO } from "../../../constants/reducer_names";

const initialState = {
    isAudio: false,
    isAudioStatus: '',
    isVideo: true,
    isVideoStatus: ''
};

const mediaSlice = createSlice(
    {
        name: MEDIA_INFO,
        initialState,
        reducers: {
            mediaDeviceInfo: (state, { payload }) => {
                state.isAudio = payload.isAudio;
                state.isAudioStatus = payload.isAudioStatus;
                state.isVideo = payload.isVideo;
                state.isVideoStatus = payload.isVideoStatus;
            }
        }
    }

)

export const mediaAction = mediaSlice.actions;
export default mediaSlice.reducer;